// dashboard.service.ts
import { API } from "../api";
import {
  ValorTotalResponse,
  ValorMedioCotacoesResponse,
  PorcentagemPorPaisResponse,
  PorcentagemMesAnteriorResponse,
  ValorMedioPorPaisResponse,
  CotacoesPorDataResponse,
  CotadoXEntregueResponse,
  TransportadoraDataResponse,
  PaisDestinatarioResponse,
  TrendInfosResponse,
  PaisValorResponse,
  QuantidadeStatusResponse,
} from "./dashboard.types";

/* ---------- Valores ---------- */

export const getValorTotal = async () => {
  const { data } = await API.get<ValorTotalResponse>("/dashboard/valorTotal");
  return data;
};

export const getValorMedioCotacoes = async () => {
  const { data } = await API.get<ValorMedioCotacoesResponse>(
    "/dashboard/valorMedio/cotacoes",
  );
  return data;
};

/* ---------- Porcentagens ---------- */

export const getTransportadoraData = async () => {
  const { data } = await API.get<TransportadoraDataResponse>(
    "/dashboard/porcentagem/transportadora",
  );
  return data;
};

export const getPorcentagemPorPais = async () => {
  const { data } = await API.get<PorcentagemPorPaisResponse>(
    "/dashboard/porcentagem/pais-destinatario",
  );
  return data;
};

export const getPorcentagemMesAnterior = async () => {
  const { data } = await API.get<PorcentagemMesAnteriorResponse>(
    "/dashboard/porcentagem/mesAnterior",
  );
  return data;
};

/* ---------- Médias ---------- */

export const getValorMedioPorPais = async () => {
  const { data } = await API.get<ValorMedioPorPaisResponse>(
    "/dashboard/valorMedio/pais",
  );
  return data;
};

/* ---------- Cotações por Data ---------- */

export const getCotacoesHoje = async () => {
  const { data } = await API.get<CotacoesPorDataResponse>(
    "/dashboard/cotacoesPorData/hoje",
  );
  return data;
};

export const getCotacoesOntem = async () => {
  const { data } = await API.get<CotacoesPorDataResponse>(
    "/dashboard/cotacoesPorData/ontem",
  );
  return data;
};

export const getCotacoesSemana = async () => {
  const { data } = await API.get<CotacoesPorDataResponse>(
    "/dashboard/cotacoesPorData/semana",
  );
  return data;
};

export const getCotacoesMes = async () => {
  const { data } = await API.get<CotacoesPorDataResponse>(
    "/dashboard/cotacoesPorData/mes",
  );
  return data;
};

/* ---------- Cotação X Entregues ---------- */

export const getCotadovsEntregue = async () => {
  const { data } = await API.get<CotadoXEntregueResponse>(
    "/dashboard/envioVsCotacao",
  );
  return data;
};

/* ---------- Infos ---------- */

export const getInfosBreves = async () => {
  const { data } = await API.get<TrendInfosResponse>("/dashboard/infosBreves");
  return data;
};

/* ---------- Paises ---------- */

export const getPaisDestinatario = async () => {
  const { data } = await API.get<PaisDestinatarioResponse>(
    "/dashboard/porcentagem/pais-destinatario",
  );
  return data;
};

export const getPaisValores = async () => {
  const { data } = await API.get<PaisValorResponse>(
    "/dashboard/paises/valores",
  );
  return data;
};

/* ---------- Status ---------- */

export const getQuantidadeStatus = async () => {
  const { data } = await API.get<QuantidadeStatusResponse>(
    "/dashboard/quantidadeStatus",
  );
  return data;
};
